import { render, staticRenderFns } from "./channelLog.vue?vue&type=template&id=2c4cd01c&scoped=true&"
import script from "./channelLog.vue?vue&type=script&lang=js&"
export * from "./channelLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4cd01c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c4cd01c')) {
      api.createRecord('2c4cd01c', component.options)
    } else {
      api.reload('2c4cd01c', component.options)
    }
    module.hot.accept("./channelLog.vue?vue&type=template&id=2c4cd01c&scoped=true&", function () {
      api.rerender('2c4cd01c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/channel/list/channelLog.vue"
export default component.exports